import React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import './IssueListItem.css';

class IssueListItem extends React.Component {
  render() {
    const { translate } = this.props;
    const counterText = this.props.counter === 1
      ? translate('destination.issue_count_in_destination_singular')
      : translate('destination.issue_count_in_destination_plural');

    return (
      <div className="row issuelist-item text-6">
        <div className="col-sm-2 text-5 alert-color">
          {this.props.counter}
          {' '}
          {counterText}
        </div>
        <div className="col-sm-3">
          {this.props.customerName}
        </div>
        <div className="col-sm-3">
          {this.props.companyName}
        </div>
        <div className="col-sm-4">
          {this.props.streetAddress}
          ,
          {' '}
          {this.props.postalCode}
          ,
          {' '}
          {this.props.city}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  return {
    translate: getTranslate(locale),
  };
};

export default connect(
  mapStateToProps,
  null,
)(IssueListItem);
